var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.isPriceEmpty)?_c('span',[_vm._v(_vm._s(_vm.priceObj.integer)),_c('span',{staticClass:"decimal-up",style:(_vm.decimalStyles)},[_vm._v(_vm._s(_vm.priceObj.decimal))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }